import React, { type ReactNode } from 'react';
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- PLEASE FIX - ENABLING FLAT LINT CONFIG
import noop from 'lodash/noop';
import Button, { ButtonGroup } from '@atlaskit/button';
import SearchIcon from '@atlaskit/icon/glyph/search';
import { useActionsCommandPalette } from '@atlassian/jira-command-palette/src/controllers/command-palette/index.tsx';
import PageHeader from '@atlassian/jira-common-components-page-header';
import { ff } from '@atlassian/jira-feature-flagging';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

declare let JIRA: {
	Shifter: {
		show: () => void;
	};
};

type AdminPagesHeaderProps = {
	title: string;
	actions?: ReactNode;
	bottomBar?: ReactNode;
};

export const AdminPagesHeader = ({ title, actions, bottomBar }: AdminPagesHeaderProps) => {
	const { formatMessage } = useIntl();

	const { open } = ff('compal-sunset-and-remove-dot-menu_66j8q')
		? // eslint-disable-next-line react-hooks/rules-of-hooks
			useActionsCommandPalette()
		: {
				open: () => JIRA.Shifter.show(),
			};

	const searchActionLabel = formatMessage(messages.searchJiraAdmin);
	const shifterAction = (
		<ButtonGroup>
			{actions}
			<Button iconBefore={<SearchIcon label="" size="small" />} onClick={open}>
				{searchActionLabel}
			</Button>
		</ButtonGroup>
	);
	return (
		<PageHeader actions={shifterAction} bottomBar={bottomBar}>
			{title}
		</PageHeader>
	);
};
